import { serializeQuery, type QueryObject } from './serializeQuery';
import type { SearchCriteria, PartialSearchCriteria, Selection } from '../model/types';
import { checkInDateRange } from './fields/checkInDateRange';
import { fromCity } from './fields/fromCity';
import { nightRange } from './fields/nightRange';
import { touristGroup } from './fields/touristGroup';
import type { Hotel } from '@/shared/model';

export function getSingleHotelId(destination: Selection<unknown, unknown, Partial<Hotel>> | null): number | null {
  if (destination?.kind === 'hotels' && destination.hotels.length === 1) {
    return destination.hotels[0].id ?? null;
  }

  return null;
}

export function getHotelUrl(criteria: SearchCriteria | PartialSearchCriteria, otherCriteria: QueryObject = {}): string {
  return serializeQuery({
    ...fromCity(criteria),
    ...checkInDateRange(criteria),
    ...nightRange(criteria),
    ...touristGroup(criteria),
    ...otherCriteria,
  });
}
